<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import { useStore } from "@/store/authStore";
import { format } from "date-fns";

import { useApiStore } from "@/store/apiStore";
import { useRoleStore } from "@/store/roleStore";
import useRole from "@/components/role";
const roleStore = useRoleStore();
const apiStore = useApiStore();
const store = useStore();
const { hasPermission } = useRole();
const tokenHeaders = store.getTokenHeaders;

/*初期値*/
const maintenance = ref({
  maintenance_flg: false,
  description: "",
});
const koshin_date = ref();

const getApiUrl = apiStore.getMaintenansPath; //`http://boatrace-prod-public-alb-958219121.ap-northeast-1.elb.amazonaws.com/api/v1/maintenans`

/*データ取得、変換、値が存在するか確認*/
onMounted(async () => {
  try {
    const response = await axios.get(getApiUrl, tokenHeaders);

    /*値が存在するか確認、値があれば代入*/
    if (response.status === 200) {
      maintenance.value.maintenance_flg =
        response.data.maintenance_flg === "1" ? true : false;

      const getNewlineCode = response.data.description;
      maintenance.value.description = String(getNewlineCode).replace(
        /<br>/g,
        "\n"
      );

      /*maintenance_flgがtrueのときのみ、時刻表示*/
      if (maintenance.value.maintenance_flg === true) {
        const jsonDate = response.data.koshin_date;
        const formattedDate = format(new Date(jsonDate), "yyyy/MM/dd HH:mm");
        koshin_date.value = formattedDate;

        /*
                const dateToString = response.data.koshin_date;
                const jsonDate = new Date(dateToString);
                //UTCからJSTへ、時差を修正する
                jsonDate.setHours(jsonDate.getHours() + 9);
                //フォーマットがyyyy/MM/dd HH:mmになるよう修正
                const formattedDate = `${jsonDate.getFullYear()}/${
                    (jsonDate.getMonth() + 1).toString().padStart(2, '0')
                    }/${jsonDate.getDate().toString().padStart(2, '0')} ${
                    jsonDate.getHours().toString().padStart(2, '0')
                    }:${jsonDate.getMinutes().toString().padStart(2, '0')}`;
                koshin_date.value = formattedDate;
                */
      }
    }
  } catch (error) {
    console.error("API取得エラー", error);
  }
});

const putApiUrl = apiStore.getMaintenancePath; //`http://boatrace-prod-public-alb-958219121.ap-northeast-1.elb.amazonaws.com/api/v1/maintenance`

/*登録ボタン押下*/
const registration = async () => {
  const isChecked = maintenance.value.maintenance_flg;
  const convertFlg = isChecked ? "1" : "0";

  const putNewlineCode = maintenance.value.description;
  const convertDiscription = String(putNewlineCode).replace(/\n/g, "<br>");

  const dataToSend = {
    maintenance_flg: convertFlg,
    description: convertDiscription,
  };

  /*更新処理put*/
  try {
    const response = await axios.put(putApiUrl, dataToSend, tokenHeaders);
    if (response.status === 200) {
      console.log("送信成功");
      alert("設定を登録しました");
      window.location.reload();
    }
  } catch (error) {
    console.error("送信エラー", error);
    alert("登録エラー　設定を登録できませんでした");
  }
};
</script>

<template>
  <div class="content_parent registration d-flex flex-column">
    <p>
      メンテナンスなどで、「メンテナンス中」にする場合、下記で「状態」をON設定し登録して下さい。解除は「状態」をOFF設定し登録して下さい。
    </p>
    <div class="title content_line">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle mnt_texttitle">状態</div>
        </div>
        <div class="content_item">
          <label for="maintenance_flg">メンテナンス中</label>
          <input
            id="maintenance_flg"
            type="checkbox"
            v-model="maintenance.maintenance_flg"
          />
        </div>
      </div>
    </div>
    <div class="title content_line">
      <div class="item_parent">
        <div class="content_title">
          <div class="texttitle mnt_texttitle">メンテナンス設定時刻</div>
        </div>
        <div class="content_item">
          <span v-text="koshin_date" />
        </div>
      </div>
    </div>
    <div class="title content_line">
      <div class="item_parent">
        <div class="texttitle mnt_texttitle">コメント</div>
        <div class="content_item" id="comment_textarea">
          <textarea
            class="form-control"
            id="description"
            name="description"
            maxlength="500"
            v-model="maintenance.description"
          />
        </div>
      </div>
    </div>
    <div class="registration_button">
      <button
        :disabled="!hasPermission(roleStore.role, 'MAINTENANCE')"
        class="submit_button"
        v-on:click="registration"
      >
        登録
      </button>
    </div>
  </div>
</template>

<style scoped>
.registration_button {
  width: 40%;
}

#description {
  width: 50em !important;
  min-height: 8em !important;
}

.mnt_texttitle {
  min-width: 12em !important;
  max-width: 12em !important;
}
</style>
